import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ErrorLabel from "../error_label";
import CityDropdown1 from "../../routes/app/auth/new_vehicles/rto.json";
import CityDropdown from "../../routes/app/auth/new_vehicles/cities_v1.json";
import TermsConditions from "../popups/t&c";
import {
  actionZoneList,
  resetZoneListResponse,
} from "../../routes/app/public/store";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../common/app_constant";
import toast from "react-hot-toast";
import { numberWheelChange } from "../../utils";
const Registration = (props) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      code: "axis",
      corporate_id: "1",
      role_id: "2",
      city_id: null,
      is_accepted_terms: true
    },
  });
  const dispatch = useDispatch();
  const navigate =useNavigate()
  const [selectedValue, setSelectedValue] = useState("");
  const [zonDropdownValue, setZoneDropdownValue] = useState();
  const [zoneLists, setZoneLists] = useState([]);
  const { zoneList } = useSelector((state) => ({
    ...state.publicStore,
  }));

  useEffect(() => {
    dispatch(actionZoneList());
  }, []);

  useEffect(() => {
    if (zoneList) {
      dispatch(resetZoneListResponse());
      if (zoneList?.status) {
        setZoneLists(zoneList?.data);
      } else {
        switch (zoneList?.state_id) {
          case 400:
            toast.error(zoneList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login");
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [zoneList]);

  const onRegSubmit = async (data) => {
    props.handleReg(data);
  };

  const generateCityList = () => {
    var menu = [];
    if (zoneLists && zoneLists.length ) {
      let cities = zoneLists;
      cities.forEach(function (child, labelIndex) {
        menu.push(
          <option key={child.id} value={child.id}>
            {child.name}
          </option>
        );
      });
    }
    return menu;
  };

  const getZoneDropdown = () => {
    var menu = [];

    if (!!zoneLists && zoneLists?.length) {
      zoneLists.forEach(function (child, labelIndex) {
        menu.push(
          <option key={child.id} value={child.id}>
            {child.zone}
          </option>
        );
      });
    }
  };

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <form onSubmit={handleSubmit(onRegSubmit)}>
      <div className="align-items-center justify-content-center justify-content-lg-start mb-3">
        <p className="lead fw-bold me-3 text-secondary">
          <span className="text-dark">Register Now</span>
        </p>
      </div>
      {/* mobile input */}
      <div className="form-outline mb-4">
        <div>
          <label className="form-label" htmlFor="full_name">
            Full Name<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            id="full_name"
            name="full_name"
            className="form-control form-control-lg"
            placeholder="Enter Your Full Name"
            onKeyPress={(e) => {
              if (!/^[A-Za-z. ]*$/.test(e.key)) {
                // If the key pressed doesn't match the pattern, prevent the default action (typing the character)
                e.preventDefault();
              }
            }}
            maxLength={55}
            {...register("full_name", {
              required: "This is required.",
                pattern: {
                  value:  /^[A-Za-z. ]*$/,
                  message: "invalid first Name",
                },
            })}
            
          />
          {errors.full_name && (
            <ErrorLabel message={errors.full_name?.message} />
          )}
        </div>
        <div className="mt-3 d-none">
          <label className="form-label" htmlFor="zone">
            Zone
          </label>
          <select
            id="zone"
            name="zone"
            className="form-control"
            {...register("zone", {
              // required: "This is required",
              // make required when data is from api
            })}
          >
            <option value="">Zone</option>
            {getZoneDropdown()}
          </select>
        </div>
        <div className="mt-3">
          <label className="form-label" htmlFor="mobile">
            Mobile No.<span className="text-danger">*</span>
          </label>
          <input type="hidden" name="code" value="axis"></input>
          <input
            type="number"
            id="mobile"
            name="mobile"
            onFocus={numberWheelChange}
            className="form-control form-control-lg"
            placeholder="Enter a valid mobile number"
            onInput={(e) => {
              if (e.target.value.length > 10) {
                e.target.value = e.target.value.slice(0, 10);
              }
            }}
            {...register("mobile", {
              required: "This is required.",
                pattern: {
                  value: /^[0-9]{10}$/i,
                  message: "invalid mobile number",
                },
            })}
          />
          {errors.mobile && <ErrorLabel message={errors.mobile?.message} />}
        </div>
        <div className="mt-3">
          <label className="form-label" htmlFor="email">
            Email ID<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            id="email"
            name="email"
            className="form-control form-control-lg"
            placeholder="Enter a valid email id"
            {...register("email", {
              required: "This is required.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "invalid email address",
              },
            })}
          />
          {errors.email && <ErrorLabel message={errors.email?.message} />}
          {/* {errors.email && <ErrorLabel message={errors.email?.message} />} */}
        </div>
        <div className="mt-3">
          <label htmlFor="policyType" className="form-label">
            City<span className="text-danger">*</span>
          </label>
          <select
            id="city_id"
            name="city_id"
            className="form-control form-select"
            {...register("city_id", {
              required: "This is required.",
            })}
          >
            <option>Select City</option>
            {generateCityList()}
          </select>
          {/* {errors.policy_types_id && (
                          <ErrorLabel
                            message={errors.policy_types_id?.message}
                          />
                )} */}
        </div>
        <div class="col-12 mt-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="is_accepted_terms" defaultChecked
            {...register("is_accepted_terms" , {
              required:"Please accept Terms and Conditions"
            })}/>
            <label class="form-check-label " for="is_accepted_terms">
              <a data-bs-toggle="modal" data-bs-target="#exampleModal" className="text-primary">
                Accept T&C
              </a>
            </label><br/>
            
          </div>
          {errors.is_accepted_terms && <ErrorLabel message={errors.is_accepted_terms?.message}/>}
        </div>
      </div>
      <div className="text-center text-lg-start mt-4">
        <button type="submit" className="btn btn-primary w-100">
          Get OTP
        </button>
      </div>
    <TermsConditions/>
    </form>
  );
};

export default Registration;
